var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('splash-screen',{staticClass:"home"},[_c('h2',[_vm._v(_vm._s(_vm.$t('core.splash.welcome')))]),_c('cockpit-title',{attrs:{"large":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }